
import { useEffect, useState } from 'react'
import Image from 'next/image'
import { useTranslation } from 'src/utils/i18n'
import { Icon } from '@iconify/react'

const Preparation = (props) => {
  const { t } = useTranslation('common')
  const [checked, setChecked] = useState(false)


  return (
    <div className='Mlg:px-[24px] max-w-[435px] w-full flex flex-col items-center'>
      <div className='text-[#282938] Mlg:mt-[14px] text-center flex flex-col'>
        <p className='text-[24px] leading-[36px] font-semibold'>{t('Before you begin')}</p>
        <p className='text-[18px] leading-[26px] font-medium mt-[10px]'>{t('Preparation for successful Connection')}</p>
      </div>
      <div className='max-w-[374px] w-full mt-[24px] flex items-start justify-center p-[12px] bg-[#FFFFFF] rounded-[8px] shadow-[0px_1px_6px_0px_#28293826]'>
        <Image
          src='/images/apps/hint.svg'
          className='flex w-[24px] h-[24px] mr-[12px]'
          alt='img'
          width={24}
          height={24}
        />
        <p className='text-[14px] leading-[22px] Mlg:text-[12px] Mlg:leading-[20px] text-[#282938]'>
          {t('Please note that all information and devices mentioned below refer to the')} <b>{t('target device')}</b> {t('you wish to monitor not your own phone')}
        </p>
      </div>

      <div className='Mlg:mt-[16px] mt-[32px] flex flex-col justify-start gap-y-[12px]'>
        <div className="flex items-start">
          <Icon icon="teenyicons:circle-solid" className='w-[8px] h-[8px] text-[#2A99FF] mr-[11px] mt-[8px] flex-shrink-0' />
          <span className="text-[15px] leading-relaxed text-[#282938] font-[600]">
            {t('iCloud account and password of the target device')}
          </span>
        </div>
        <div className='flex justify-between items-center p-[10px] rounded-[8px] bg-[linear-gradient(90deg,#6B51FE_0%,#06BAFD_100%)] text-[12px] leading-[20px] font-normal text-[#FFFFFF]'>
          <p>{t('Not sure which account to use')}</p>
          <div className='flex items-center'>
            <Image
              src='/images/apps/user.svg'
              className='w-[18px] h-[18px] mr-[10px]'
              alt='help'
              width={18}
              height={18}
            />
            <a href='https://support.apple.com/en-us/102627' target="_blank" rel="noopener noreferrer" className='cursor-pointer underline'>{t('Find it here')}</a>
          </div>
        </div>
        <div className="flex items-start">
          <Icon icon="teenyicons:circle-solid" className='w-[8px] h-[8px] text-[#2A99FF] mr-[11px] mt-[8px] flex-shrink-0' />
          <span className="text-[15px] leading-relaxed text-[#484B60] font-normal">
            {t('Devices or phone numbers trusted by the iCloud account for two-factor authentication')}
          </span>
        </div>
        <div className="flex items-start">
          <Icon icon="teenyicons:circle-solid" className='w-[8px] h-[8px] text-[#2A99FF] mr-[11px] mt-[8px] flex-shrink-0' />
          <span className="text-[15px] leading-relaxed text-[#484B60] font-normal">
            {t('Stable internet connection')}
          </span>
        </div>
        <div className="flex items-start">
          <Icon icon="teenyicons:circle-solid" className='w-[8px] h-[8px] text-[#2A99FF] mr-[11px] mt-[8px] flex-shrink-0' />
          <span className="text-[15px] leading-relaxed text-[#484B60] font-normal">
            {t('5 minutes of uninterrupted time')}
          </span>
        </div>
      </div>
      <div className='flex items-center mt-[86px] smj:mt-10'>
        <input
          type="checkbox"
          checked={checked}
          onChange={() => {
            const nextChecked = !checked
            setChecked(nextChecked)
          }}
          className=" appearance-none w-[16px] h-[16px] border border-[#165DFF] rounded-[2px] cursor-pointer transition-all duration-200 checked:bg-[#165DFF] checked:border-[#165DFF]
                      checked:bg-[url('/images/apps/shape.svg')] checked:bg-no-repeat checked:bg-center checked:bg-[length:10px_10px] focus:outline-none
                    "
        />
        <p className='ml-[6px] text-[#282938] text-[12px] leading-[20px]'>{t('I have all the above items ready')}</p>
      </div>
      <div className='w-[266px] Mlg:w-full flex justify-center items-center mt-[16px] Mlg:pb-[32px]'>
        <button
          disabled={!checked}
          className={`w-full h-[60px] Mlg:h-[50px] mx-auto text-[#282938] text-[16px] font-[600] rounded-[41px] flex justify-center items-center
                      bg-[#FFCF55]
                      ${!checked ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'}
                    `}
          onClick={() => {
            if (!checked) return
            props.onStart()
          }}
        >
          {t('Start to connect')}
        </button>
      </div>
    </div>
  )
}

export default Preparation